<!--全屏看版-->
<template>
	<div class="billboardBody">
		<!--头部-->
		<div class="billboardTitle" :style="getBackgroudImageStyle('huanbao/billboard/titleBg.png')">
			<div class="titleLeft">
				<span>{{new Date(currentTime).format('yyyy-MM-dd hh:mm:ss')}}</span>
			</div>
			<div>
				<img :src='getResourcesByName("/huanbao/billboard/log.png")' />
				<img :src='getResourcesByName("/huanbao/billboard/name.png")' />
			</div>
			<div class="titleRight">
				<img :src="getResourcesByName('/huanbao/billboard/dropOut.png')" @click="dropOut($router.push('huanbaoHome'))"/>
			</div>
		</div>
		<!--中间-->
		<div class="billboardIntermediate">
			<middleLeft/>
			<middleMap/>
			<middleRight/>
		</div>
		<!--底部-->
		<div class="billboardBottom">
			<div class="billboardBottomContent" :style="getBackgroudImageStyle('/huanbao/billboard/quyuyc.png')">
				<div class="billboardBottomTitle" :style="getBackgroudImageStyle('/huanbao/billboard/title.png')">
					<span class="colorBlue">各区域异常统计</span>
				</div>
				<!--异常区域统计-->
				<div class="qytj">
					<vchart style="height:100%;width: 100%;" ref='vchartQytj'/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import middleLeft from '@/page/system/huanbaoyongdiang/billboard/middleLeft.vue'
	import middleMap from '@/page/system/huanbaoyongdiang/billboard/middleMap.vue'
	import middleRight from '@/page/system/huanbaoyongdiang/billboard/middleRight.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			middleLeft,
			middleMap,
			middleRight,
			vchart,
		},
		props: {},
		data() {
			return {
				options: {},
				currentTime:new Date()
			}
		},
		created() {},
		mounted() {
			this.quyuYican()
			setInterval(load=>{
				this.currentTime=new Date()
			},100)
		},
		destroyed() {},
		computed: {
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			}
		},
		watch: {},
		methods: {
			quyuYican() {
				//各区域异常企业
				let options = this.$refs.vchartQytj.getDefaultOptions()
				options.xAxis = {
					splitLine: {
						show: false
					}, //去除网格线
					type: 'category',
					data: [{
						value: '珠海环保局',
						textStyle: {
							color: '#309efe'
						}
					}, {
						value: '广州环保局',
						textStyle: {
							color: '#309efe'
						}
					}, {
						value: '深圳环保局',
						textStyle: {
							color: '#309efe'
						}
					}, {
						value: '湛江环保局',
						textStyle: {
							color: '#309efe'
						}
					}, {
						value: '雷州环保局',
						textStyle: {
							color: '#309efe'
						}
					}, {
						value: '河源环保局',
						textStyle: {
							color: '#309efe'
						}
					}, {
						value: '天津环保局',
						textStyle: {
							color: '#309efe'
						}
					}, {
						value: '重庆环保局',
						textStyle: {
							color: '#309efe'
						}
					}, {
						value: '北京环保局',
						textStyle: {
							color: '#309efe'
						}
					}],
					nameTextStyle: {
						color: 'red',
					}
				}
				options.title = {
					text: '',
				}
				options.toolbox = {
					show: false
				}
				options.yAxis = {
					splitLine: {
						show: false
					}, //去除网格线
					axisLabel: {
						formatter: '{value}',
						textStyle: {
							color: '#ffffff',
						}
					}
				}
				options.series = [{
					barMaxWidth: '35',
					itemStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(
								0, 0, 0, 1, [{
										offset: 0,
										color: '#08b2e2'
									},
									{
										offset: 0.5,
										color: '#0079e4'
									},
									{
										offset: 1,
										color: '#000af5'
									}
								]
							)
						},
						emphasis: {
							color: new echarts.graphic.LinearGradient(
								0, 0, 0, 1, [{
										offset: 0,
										color: '#2378f7'
									},
									{
										offset: 0.7,
										color: '#2378f7'
									},
									{
										offset: 1,
										color: '#08b2e2'
									}
								]
							)
						}
					},
					data: [120, 200, 150, 80, 70, 110, 130, 140, 150],
					type: 'bar'
				}]
				options.tooltip = {
					trigger: 'axis',
					confine: true,
					formatter: (params, ticket, callback) => {
						var label = ''
						params.forEach(item => {
							var values;
							if(isnull(item.value)) {
								values = "无采集数据";
							} else {
								values = item.value;
							}
							label += item.axisValue + " : " + values + "</br>"
						})
						return label;
					},
					axisPointer: {
						animation: false
					}
				}
				options.grid = {
						height: '80%',
						width: '',
						left: '1%',
						right: '3%',
						bottom: '1%',
						containLabel: true
					},
				this.$refs.vchartQytj.setData(options, true)
			}
		}
	}
</script>

<style scoped>
	.colorBlue {
		color: #309efe !important;
	}
	
	.billboardBody {
		position: fixed;
		width: 100% !important;
		height: 100%;
		background-color: #000824;
		top: 0;
	}
	
	.billboardTitle {
		width: 100%;
		height: 10%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.billboardIntermediate {
		width: 100%;
		height: 60%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.billboardBottom {
		width: 100%;
		height: 30%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.billboardBottomContent {
		width: 98%;
		height: 96%;
	}
	
	.billboardBottomTitle {
		width: 8%;
		height: 10%;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.billboardBottomTitle span {
		font-size: .16rem;
	}
	
	.qytj {
		width: 100%;
		height: 90%;
	}
	.titleLeft{
		width: 20%;
		padding-bottom: .2rem;
		padding-left: .4rem;
	}
	.titleLeft span{
		color: #309efe;
		
	}
	.titleRight{
		width: 20%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-right: .4rem;
	}
	.titleRight img{
		padding-bottom: .2rem;
	}
</style>